import { render, staticRenderFns } from "./KanbanReady.vue?vue&type=template&id=5df532a7&scoped=true&lang=pug&"
import script from "./KanbanReady.vue?vue&type=script&lang=js&"
export * from "./KanbanReady.vue?vue&type=script&lang=js&"
import style0 from "./KanbanReady.vue?vue&type=style&index=0&id=5df532a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df532a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VImg,VLayout,VProgressCircular,VRow})
